import React from "react";
import { useNavigate } from "react-router-dom";

const PackageDetail = () => {
  const navigate = useNavigate();

  const packageInfo = [
    { label: "Package Name", value: "Premium Plan" },
    { label: "Best Value", value: "Yes" },
    { label: "Price / Month", value: "$49" },
    { label: "Created Date", value: "01 March 2025" },
  ];

  const features = [
    "Unlimited Bookings",
    "Priority Support",
    "Advanced Analytics",
    "Custom Branding",
  ];

  return (
    <>
      {/* Page Title */}
      <div className="main_title">
        <h1>Package Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> –{" "}
          <button onClick={() => navigate("/manage-packages")}>
            Manage Packages
          </button>{" "}
          – Package Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          {packageInfo.map((item, index) => (
            <div className="w_33" key={index}>
              <h6>{item.label}</h6>
              <p>{item.value}</p>
            </div>
          ))}

          {/* Features Section */}
          <div className="w_100">
            <h6>Features</h6>
            <ul className="feature_list">
              {features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default PackageDetail;
